export function useVersion(): string {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore global variable
  return process.env.NODE_ENV === "production" ? APP_VERSION : "local";
}
